import pwaConfigStatic from "../../../../static/pwa-config.json";
import pwaConfigGPAYStatic from "../../../../static/pwa-config-GPAY.json";
import pwaConfigPAYTMStatic from "../../../../static/pwa-config-PAYTM.json";
import appConfigStatic from "../../../../static/app-config.json";
import appConfigGPAYStatic from "../../../../static/app-config-GPAY.json";
import appConfigPAYTMStatic from "../../../../static/app-config-PAYTM.json";
import { keyMapsAction, keyMapsMutation } from "../../helpers/storeKeys";
import localStorageFunc from "../../helpers/localStorageFunc";
import get from "lodash/get";
import Utility from "../../helpers/utility";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import {
  isCorporateSite,
  postOrderUIBasePath,
} from "../../config/apiEndpoints";
import { ORDER_TYPE } from "../../helpers/paymentConstants";
import location from "../../config/location";

const initialConfig = (store) => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const elePgWrapper = document.getElementsByClassName("pg-wrapper")[0]
  if(!isMobile){
    elePgWrapper.classList.add("desktop-view");
  } else {
    elePgWrapper.classList.remove("desktop-view");
  }
  const isRelayPage = Utility.isRelayPage();
  const isLoyaltyPage = Utility.isLoyaltyPage();

  if (isRelayPage) {
    return;
  }

  const queryObj = Utility.getQueryFromUrlWithSpace(window.location.href) || {};
  const assetName = queryObj["platform"];

  if (isLoyaltyPage && assetName) {
    let storeId = null;
    try {
      storeId = window.location.pathname.split("/").pop();
      if (!storeId) {
        storeId = "6585R";
      }
    } catch (error) {
      storeId = "6585R";
    }
    localStorage.storeId = storeId;
  }

  const qrOrder =
    window.location.href.includes("/qr") &&
    Utility.getLinkRewriteFromSiteprops() === "qr";
  if (qrOrder) {
    const queryParams = new URLSearchParams(window.location.search);
    const storeId =
      queryParams.get("storeid") || queryParams.get("storeId") || location.defaultStoreId;
    const orderType =
      (
        queryParams.get("ordertype") || queryParams.get("orderType")
      )?.toUpperCase() || ORDER_TYPE.DINEIN;

    localStorage.setItem("storeId", storeId);
    LocalStorageFunc.setDeliveryType(orderType);
  }

  if (isCorporateSite) {
    const corpUserInfo = LocalStorageFunc.getCorporateUserInfo();
    const loginPageUrl = `/${postOrderUIBasePath}login`;
    if (corpUserInfo) {
      const corporateAppDisableState =
        Utility.isCorporateOrderingDisabled() || {};
      if (corporateAppDisableState.disable) {
        LocalStorageFunc.setCorporateUserInfo({});
        Utility.showCorporateDisabledError(corporateAppDisableState);
        return;
      }
      const isCorporateLoggedIn = get(
        corpUserInfo,
        "headers.isCorporateLoggedIn",
        false,
      );
      const isLdapTokenExpired =
        Date.now() > corpUserInfo?.headers?.tokenExpiresAt;
      if (isLdapTokenExpired || !isCorporateLoggedIn) {
        window.location = loginPageUrl;
        return;
      }
    } else {
      window.location = loginPageUrl;
      return;
    }
  }
  let isReorderViaOrderHistory =
    LocalStorageFunc.getStorageValue("isFromReOrder") == "true";
  if (isReorderViaOrderHistory) {
    LocalStorageFunc.setLocalStorageValue("reorderHistoryId", "");
    LocalStorageFunc.setLocalStorageValue("isFromReOrder", "false");
  }
  LocalStorageFunc.setLocalStorageValue("confrimView", false);
  const userInfo = localStorageFunc.getUserData();
  const sessionToken = get(userInfo, "headers.credentials.sessionToken", null);
  const refreshToken = get(userInfo, "headers.credentials.refreshToken", null);
  if (!sessionToken && !refreshToken) {
    store.dispatch(keyMapsAction.ANONYMOUS_USER_API);
  }

  const [pwaConfigObj, appConfigObj] = Utility.checkIfIsGpay()
    ? [pwaConfigGPAYStatic, appConfigGPAYStatic]
    : Utility.checkIfIsPAYTM()
      ? [pwaConfigPAYTMStatic, appConfigPAYTMStatic]
      : [pwaConfigStatic, appConfigStatic];
  store.commit(keyMapsMutation.UPDATE_PWA_CONFIG, pwaConfigObj, { root: true });
  store.commit(keyMapsMutation.UPDATE_APP_CONFIG, appConfigObj, { root: true });
  store.dispatch("Config/getPWAConfig", {}, { root: true });
  store.dispatch("Config/getAppConfig", {}, { root: true });
};

export default initialConfig;
